import { createContext, Dispatch, SetStateAction } from "react";
import { SurveyInstance } from "../components/Survey";

export const SurveyContext = createContext<{
  instance: SurveyInstance;
  setInstance: Dispatch<SetStateAction<SurveyInstance>>;
}>({
  instance: {
    questionAnswers: [],
    updates: [],
  },
  setInstance: () => { },
});
